<div class="usp-section-container">
  <div class="usp-image-container">
    <img src="https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/67e6798bbffa03a7b6f38220_Foto%2008.04.24%2C%2010%2006%2016.jpg" alt="USP Image" class="usp-image" />
    <div class="usp-quote">
      <span>Erfolg ist die beste Rache für all jene, die an dir gezweifelt haben.“</span>
    </div>
  </div>
  <div class="usp-cards-grid">
    <div class="usp-card" *ngFor="let card of cards">
      <div class="usp-card-icon">
        <img [src]="card.icon" alt="" *ngIf="card.icon.endsWith('.svg') || card.icon.endsWith('.png')" />
        <mat-icon *ngIf="!card.icon.endsWith('.svg') && !card.icon.endsWith('.png')">{{ card.icon }}</mat-icon>
      </div>
      <div class="usp-card-title">{{ card.title }}</div>
      <div class="usp-card-description">{{ card.description }}</div>
    </div>
  </div>
</div> 